import React from 'react'
import "../css/spinner.css"

function Spinner () {

  return (
    <span className={'react-spinner'}/>
  )
}

export default Spinner